export const SFMC_ARCHITECTURE_PIPELINE = [
  {
    id: "data-extension",
    title: "Data Extension",
    icon: "database",
    color: "#2dd4bf",
    summary: "The core table structure in SFMC — every subscriber, purchase record, and event log lives in a Data Extension.",
    details: [
      "A Data Extension (DE) is a custom table with typed columns — the fundamental storage unit in SFMC, used for subscriber lists, transactional data, and preference records.",
      "DEs can be Sendable (has a subscriber relationship, can be used as a Journey/email entry source) or Non-Sendable (lookup/reference tables joined via SQL Query Activities).",
      "Every downstream SFMC feature — Automation Studio imports, Journey entry sources, AMPscript lookups — ultimately reads from or writes to a Data Extension.",
    ],
  },
  {
    id: "contact-model",
    title: "Contact Model",
    icon: "fingerprint",
    color: "#38bdf8",
    summary: "Contact Builder links a subscriber's data across multiple Data Extensions into one Contact record via a Contact ID.",
    details: [
      "The Contact Model (Contact Builder) associates multiple Data Extensions and Attribute Groups to a single Contact via a shared Contact ID.",
      "This lets a Journey or Send reference attributes that live across several DEs (e.g., loyalty tier in one DE, purchase history in another) as one coherent contact.",
      "Attribute Groups define which fields are exposed for personalization and entry-source targeting across Journey Builder.",
    ],
  },
  {
    id: "content-builder",
    title: "Content Builder",
    icon: "layers",
    color: "#a78bfa",
    summary: "Where emails, templates, and reusable Content Blocks are authored — with AMPscript/Handlebars personalization.",
    details: [
      "Content Builder is the asset library for emails, templates, images, and reusable Content Blocks shared across campaigns.",
      "AMPscript (and newer Handlebars-style syntax) embedded in content pulls live Data Extension values at send time for personalization.",
      "A change to a shared Content Block propagates to every email/journey step referencing it — the core reuse mechanism in SFMC.",
    ],
  },
  {
    id: "automation-studio",
    title: "Automation Studio",
    icon: "waves",
    color: "#f59e0b",
    summary: "Runs sequential, scheduled or triggered activity chains — imports, SQL queries, file transfers — with no branching.",
    details: [
      "Automation Studio executes a linear chain of activities (Import File, Query Activity, Data Extract, Script Activity) on a schedule or file-drop trigger.",
      "It has no decision-branching logic — that's Journey Builder's job. Automation Studio is for data prep pipelines that feed Journeys and sends.",
      "A typical pattern: nightly Import File → Query Activity joins/filters → resulting DE becomes a Journey's entry source the next morning.",
    ],
  },
  {
    id: "journey-builder",
    title: "Journey Builder",
    icon: "filter",
    color: "#fb7185",
    summary: "Orchestrates multi-step, branching customer journeys — entry sources, decision splits, wait activities, sends.",
    details: [
      "A Journey starts from an Entry Source (a Data Extension, API event, or Salesforce Data Event) and routes contacts through Decision Splits, Wait activities, and Send/Update activities.",
      "Decision Splits branch the path based on attribute values or engagement (e.g., opened previous email vs. not).",
      "Unlike Automation Studio, Journeys are inherently personalized and branching — built for the individual contact's path, not a batch.",
    ],
  },
  {
    id: "send-classification",
    title: "Send Classification & Deliverability",
    icon: "rocket",
    color: "#22d3ee",
    summary: "Bundles sender profile, delivery profile, and CAN-SPAM compliance settings applied at the moment of send.",
    details: [
      "A Send Classification combines a Sender Profile (from address, reply-to) and Delivery Profile (IP allocation, domain) with compliance settings.",
      "Dedicated Business Units should use their own Send Classifications to keep sender reputation and deliverability isolated from other brands.",
      "This is the last gate before an email actually leaves SFMC — misconfiguration here is the most common real-world deliverability issue.",
    ],
  },
  {
    id: "analytics-tracking",
    title: "Analytics & Tracking",
    icon: "user-check",
    color: "#34d399",
    summary: "System Data Views (_Sent, _Open, _Click, _Bounce) capture every engagement event for reporting and re-targeting.",
    details: [
      "SFMC automatically logs every send/open/click/bounce/unsubscribe into system Data Views, queryable via SQL just like any Data Extension.",
      "These Data Views feed both native Analytics Builder reports and custom SQL-driven re-engagement segments (e.g., 'opened but never clicked').",
      "This closes the loop: engagement data captured here can trigger a brand-new Journey entry, completing the SFMC architecture cycle.",
    ],
  },
];
